import { Component, Input, OnInit } from '@angular/core';
import { Article} from 'src/app/models/article';

@Component({
  selector: 'app-articles-card',
  templateUrl: './articles-card.component.html',
  styleUrls: ['./articles-card.component.scss']
})
export class ArticlesCardComponent{
  @Input() article: Article;
}
